import ReactGA from 'react-ga';

// define
if ("myrate.jp" === document.domain) {
    // GoogleAnalytics
    ReactGA.initialize('UA-107907727-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
}


// WEBPACK FOOTER //
// ./src/ga.js